var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreClassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_copy_9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.692,
    height: 20,
    viewBox: "0 0 16.692 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49783",
    "data-name": "Path 49783",
    d: "M281.145,319.238l-2.755-1.166-.8,3.248a.431.431,0,0,1-.779.137l-2.708-4.994a7.6,7.6,0,0,0,5.021-2.564l2.587,4.771A.432.432,0,0,1,281.145,319.238Z",
    transform: "translate(-265.062 -301.654)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49784",
    "data-name": "Path 49784",
    d: "M49.985,316.464l-2.7,4.994a.432.432,0,0,1-.779-.137l-.8-3.248-2.755,1.166a.43.43,0,0,1-.564-.567l2.583-4.771A7.6,7.6,0,0,0,49.985,316.464Z",
    transform: "translate(-42.335 -301.654)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49785",
    "data-name": "Path 49785",
    d: "M78.224,0a7.24,7.24,0,1,0,7.224,7.24A7.231,7.231,0,0,0,78.224,0ZM82.4,6.888,80.8,8.454l.379,2.207a.676.676,0,0,1-.547.779.694.694,0,0,1-.426-.067l-1.98-1.045-1.98,1.041a.67.67,0,0,1-.906-.282.685.685,0,0,1-.07-.431l.379-2.207-1.6-1.565a.674.674,0,0,1-.012-.951.657.657,0,0,1,.387-.2l2.21-.321L77.619,3.4a.67.67,0,0,1,.9-.305.677.677,0,0,1,.3.305l.988,2.008,2.21.321a.674.674,0,0,1,.574.759.638.638,0,0,1-.2.4Z",
    transform: "translate(-69.878)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreClassIcon);
export default __webpack_public_path__ + "static/media/storeClassIcon.41dc89c0975321387959f994414dbad4.svg";
export { ForwardRef as ReactComponent };